import { useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { businessActions, generalSelectors, businessTypes } from 'Ducks';

const useServices = () => {
	const dispatch = useDispatch();
	const businessId = useSelector((item) => item?.user?.selectedBusinessId);
	const businessList = useSelector((item) => item?.business?.list);

	const isLoading = useSelector((state) =>
		generalSelectors.selectApiLoadingStatus(
			state,
			businessTypes.BUSINESSITEM.REQUEST
		)
	);
	useEffect(() => {
		if (businessId && !businessList?.id) {
			dispatch(businessActions.getBusinessRequest({ businessId: businessId }));
		}
	}, [businessId, businessList]);

	const returnBusiness = useCallback(() => {
		if (Array.isArray(businessList)) {
			return businessList?.[0]?.attributes;
		}
		return businessList?.attributes;
	}, [businessList]);

	const checkBusinessLine = () => {
		const businessLine_name = returnBusiness()?.business_line;
		if (businessLine_name === 'offcb') return 'offline_cash_back';
		return 'core';
	};

	const newUser = useMemo(() => {
		return returnBusiness()?.has_package || returnBusiness()?.has_pos
			? false
			: true;
	}, [returnBusiness]);

	return {
		hasService: returnBusiness()?.has_package && returnBusiness()?.has_pos,
		hasOne: returnBusiness()?.has_package || returnBusiness()?.has_pos,
		hasOnlyOne: returnBusiness()?.has_package || returnBusiness()?.has_pos,
		hasPackage: returnBusiness()?.has_package,
		hasPose: returnBusiness()?.has_pos,
		businessLine: checkBusinessLine(),
		newUser,
		business: returnBusiness(),
		businessId: businessId,
		isLoading: isLoading,
	};
};

export default useServices;
